<template>
  <v-container>
    <v-row>
      <v-col class="col-9 offset-1">
        <v-row class="border-row">
          <v-col class="col-2 d-flex justify-space-between align-center flex-column">
            <v-text-field
              filled
              v-model="vRS"
              class="ma-2 text-body-1 text-field-value"
              dense
              disabled
              readonly
              hide-details
            ></v-text-field>
            <v-text-field
              filled
              v-model="vST"
              class="ma-2 text-body-1 text-field-value"
              dense
              disabled
              readonly
              hide-details
            ></v-text-field>
            <v-text-field
              filled
              v-model="vTR"
              class="ma-2 text-body-1 text-field-value"
              dense
              readonly
              disabled
              hide-details
            ></v-text-field>
          </v-col>

          <v-col class="col-5 d-flex justify-space-between align-center flex-column">
            <v-img
              v-if="getCurrentDevice.uptime.serial == false"
              src="img/brokencable.jpg"
              :max-width="180"
            ></v-img>
            <v-img
              v-else-if="getCurrentDevice.sae.s1 == 51"
              src="img/trasformatore.svg.png"
              :max-width="180"
              class="runningImage"
            ></v-img>
          </v-col>

          <v-col class="col-2 d-flex justify-space-between align-center flex-column">
            <v-text-field
              filled
              v-model="vOut"
              class="ma-2 text-body-1 text-field-value"
              dense
              readonly
              disabled
              hide-details
            ></v-text-field>
            <v-text-field
              filled
              v-model="iOut"
              class="ma-2 text-body-1 text-field-value"
              dense
              readonly
              disabled
              hide-details
            ></v-text-field>
            <v-text-field
              filled
              v-model="hzOut"
              class="ma-2 text-body-1 text-field-value"
              dense
              readonly
              disabled
              hide-details
            ></v-text-field>
          </v-col>

          <v-col class="col-1 d-flex justify-space-between align-center flex-column">
            <v-text-field
              filled
              :class="outputline1"
              dense
              readonly
              disabled
              hide-details
            ></v-text-field>
            <v-text-field
              filled
              :class="outputline2"
              dense
              readonly
              disabled
              hide-details
            ></v-text-field>
            <v-text-field
              filled
              :class="outputline3"
              dense
              readonly
              disabled
              hide-details
            ></v-text-field>
          </v-col>

          <v-col class="col-2 d-flex justify-space-between align-center flex-column">
            <v-btn class="ma-2" outlined block @click="selectOutputLine(48)">
              <span class="text-caption">{{ $t("common.command4.49") }}</span>
            </v-btn>
            <v-btn class="ma-2" block outlined @click="selectOutputLine(49)">
              <span class="text-caption">{{ $t("common.command4.50") }}</span>
            </v-btn>
            <v-btn class="ma-2" block outlined @click="selectOutputLine(50)">
              <span class="text-caption">{{ $t("common.command4.51") }}</span>
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="mt-5 border-row">
          <v-col
            style="height: fit-content"
            class="col-2 d-flex justify-start align-content-start flex-column"
          >
            <v-text-field
              dense
              readonly
              disabled
              :class="getCurrentDevice.sae.s1 == 51 ? 'text-caption ma-2 colorRun' : 'text-caption ma-2 colorError'"
              hide-details
              filled
              v-model="saeOnOffLabel"
            />
            <v-text-field
              dense
              readonly
              disabled
              class="text-caption ma-2 colorRun"
              hide-details
              filled
              v-model="saeLocalRemoteLabel"
            />
            <v-btn class="ma-2" outlined @click="toggleVoltageCurrent(48)" :class="current">
              <span class="text-caption text-uppercase">{{ $t("common.command3.48") }}</span>
            </v-btn>
            <v-btn class="ma-2" outlined @click="toggleVoltageCurrent(49)" :class="voltage">
              <span class="text-caption text-uppercase">{{ $t("common.command3.49") }}</span>
            </v-btn>
          </v-col>

          <v-col class="col-8">
            <v-row>
              <v-col class="col-3">
                <v-row>
                  <v-col class="col-12 py-0 pb-1">
                    <v-text-field
                      dense
                      readonly
                      hide-details
                      class="text-body-1 text-field-value"
                      filled
                      disabled
                      v-model="modelVoltage"
                      suffix="V"
                    />
                  </v-col>
                  <v-col class="col-12 py-0 pb-1">
                    <div
                      class="container-grad d-flex justify-space-between align-center flex-column"
                    >
                      <div class="bgColor"></div>
                      <span>
                        <span class="line line-left"></span>
                        400
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        350
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        300
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        250
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        200
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        150
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        100
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        50
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        0
                        <span class="line line-right"></span>
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="col-1 px-0 d-flex justify-center align-center">
                <v-row class="height100">
                  <v-col class="col-12">
                    <v-slider
                      v-model="sliderVoltage"
                      vertical
                      max="400"
                      min="0"
                      append-icon="mdi-plus"
                      prepend-icon="mdi-minus"
                      @click:append="up(0)"
                      @click:prepend="down(0)"
                    ></v-slider>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="col-3">
                <v-row>
                  <v-col class="col-12 py-0 pb-1">
                    <v-text-field
                      class="text-body-1 text-field-value"
                      dense
                      readonly
                      hide-details
                      filled
                      v-model="modelCurrent"
                      disabled
                      suffix="A"
                    />
                  </v-col>
                  <v-col class="col-12 py-0 pb-1">
                    <div
                      class="
                        container-grad container-grad2
                        d-flex
                        justify-space-between
                        align-center
                        flex-column
                      "
                    >
                      <div class="bgColor bgColor2"></div>
                      <span>
                        <span class="line line-left"></span>
                        20.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        18.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        16.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        14.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        12.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        10.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        8.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        6.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        4.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        2.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        0.0
                        <span class="line line-right"></span>
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="col-1 px-0 d-flex justify-center align-center">
                <v-row class="height100">
                  <v-col class="col-12">
                    <v-slider
                      v-model="sliderCurrent"
                      vertical
                      max="20.0"
                      min="0.0"
                      append-icon="mdi-plus"
                      prepend-icon="mdi-minus"
                      @click:append="up(1)"
                      @click:prepend="down(1)"
                    ></v-slider>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="col-3">
                <v-row>
                  <v-col class="col-12 py-0 pb-1">
                    <v-text-field
                      dense
                      readonly
                      hide-details
                      class="text-body-1 text-field-value"
                      filled
                      disabled
                      v-model="modelFrequency"
                      suffix="Hz"
                    />
                  </v-col>
                  <v-col class="col-12 py-0 pb-1">
                    <div
                      class="container-grad d-flex justify-space-between align-center flex-column"
                    >
                      <div class="bgColor bgColor2"></div>
                      <span>
                        <span class="line line-left"></span>
                        30.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        28.0
                        <span class="line line-right"></span
                      ></span>
                      <span>
                        <span class="line line-left"></span>
                        26.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        24.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        22.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        20.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        18.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        16.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        14.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        12.0
                        <span class="line line-right"></span>
                      </span>
                      <span>
                        <span class="line line-left"></span>
                        10.0
                        <span class="line line-right"></span>
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="col-1 px-0 d-flex justify-center align-center">
                <v-row class="height100">
                  <v-col class="col-12">
                    <v-slider
                      v-model="sliderFrequency"
                      vertical
                      max="30.0"
                      min="10.0"
                      append-icon="mdi-plus"
                      prepend-icon="mdi-minus"
                      @click:append="up(2)"
                      @click:prepend="down(2)"
                    ></v-slider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>

          <v-col class="col-2 d-flex py-0 justify-space-between align-center flex-column " style="height: fit-content">
            <v-text-field
              dense
              disabled
              readonly
              hide-details
              filled
              :class="getCurrentDevice.sae.alarm.pem ? 'text-caption colorError mb-2' : 'text-caption colorRun mb-2'"
              :value="$t('device.alarm.pem')"
            />
            <v-text-field
              dense
              disabled
              readonly
              hide-details
              filled
              :class="getCurrentDevice.sae.alarm.fuse ? 'text-caption colorError mb-2' : 'text-caption colorRun mb-2'"
              :value="$t('device.alarm.fuse')"
            />
            <v-text-field
              dense
              disabled
              readonly
              hide-details
              filled
              :class="getCurrentDevice.sae.alarm.telr && getCurrentDevice.sae.s5 == 48 ? 'text-caption colorError mb-2' : 'text-caption colorRun mb-2'"
              :value="$t('device.alarm.telr') + 1"
            />
            <v-text-field
              dense
              disabled
              readonly
              hide-details
              filled
              :class="getCurrentDevice.sae.alarm.telr && getCurrentDevice.sae.s5 == 49 ? 'text-caption colorError mb-2' : 'text-caption colorRun mb-2'"
              :value="$t('device.alarm.telr') + 2"
            />
            <v-text-field
              dense
              disabled
              readonly
              hide-details
              filled
              :class="getCurrentDevice.sae.alarm.telr && getCurrentDevice.sae.s5 == 50 ? 'text-caption colorError mb-2' : 'text-caption colorRun mb-2'"
              :value="$t('device.alarm.telr') + 3"
            />
            <v-text-field
              dense
              disabled
              readonly
              hide-details
              filled
              :class="getCurrentDevice.sae.alarm.ht ? 'text-caption colorError mb-2' : 'text-caption colorRun mb-2'"
              :value="$t('device.alarm.ht')"
            />
            <v-text-field
              dense
              disabled
              readonly
              hide-details
              filled
              :class="getCurrentDevice.sae.alarm.ss ? 'text-caption colorError mb-2' : 'text-caption colorRun mb-2'"
              :value="$t('device.alarm.ss')"
            />
            <v-text-field
              dense
              disabled
              readonly
              hide-details
              filled
              :class="getCurrentDevice.sae.alarm.rtc ? 'text-caption colorError mb-2' : 'text-caption colorRun mb-2'"
              :value="$t('device.alarm.rtc')"
            />
            <v-text-field
              dense
              readonly
              hide-details
              disabled
              filled
              :class="getCurrentDevice.sae.alarm.sqf ? 'text-caption colorError mb-2' : 'text-caption colorRun mb-2'"
              :value="$t('device.alarm.sqf')"
            />  
          </v-col>
        </v-row>
      </v-col>

      <v-col class="col-1 d-flex py-0 justify-center align-center flex-column">
        <v-btn
          fab
          x-large
          class="mb-5 colorBtn"
          @click="handleRunButton()"
          :class="[getCurrentDevice.sae.s1 == 51 ? 'colorRun' : 'colorStop', 'mb-5 transitionColor']"
          :disabled="getCurrentDevice.sae.s1 != 51 && (nextMode == null || nextLine == null)"
        >
          <span class="text-body-1 font-weight-bold">{{ $t("button.run") }}</span>
        </v-btn>
        <v-btn fab x-large @click="handleStopButton()" color="red lighten-1" class="ma-5">
          <span class="text-body-1 font-weight-bold" style="color: #fff">{{
            $t("button.stop")
          }}</span>
        </v-btn>
        <v-btn fab x-large @click="handleResetButton()" color="grey darken-3" class="mt-5">
          <span class="text-body-1 font-weight-bold" style="color: #fff">{{
            $t("button.reset")
          }}</span>
        </v-btn>
      </v-col>
    </v-row>

    <dialog-confirm-wr-request
      v-if="dialogSiteClear"
      :dialog="dialogSiteClear"
      :snapshot="inboundSnapshot"
      :gps="getCurrentDevice.sensors.gps"
      @cancel="inboundLatencyChecked = false, dialogSiteClear = false"
      @confirm="setDevice"
    ></dialog-confirm-wr-request>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import DialogConfirmWrRequest from "./DialogConfirmWrRequest.vue"

export default {
  components: {
    DialogConfirmWrRequest
  },
  data() {
    return {
      sliderVoltage: 0,
      sliderCurrent: 0,
      sliderFrequency: 0,

      modelVoltage: 0,
      modelCurrent: 0,
      modelFrequency: 0,

      btnClicked: null,

      isActive: false,

      wrrequest: {
        cmd1: 48,
        cmd2: 48,
        cmd3: 48,
        cmd4: 48,
        v: 0,
        i: 0,
        hz: 10
      },

      updating: false,

      timeout: null,

      inboundLatencyChecked: false,

      dialogSiteClear: false,
      inboundSnapshot: null,

      nextMode: null,
      nextLine: null,
    };
  },

  watch: {
    sliderVoltage: function () {
      if (this.sliderVoltage != null) {
        this.modelVoltage = this.sliderVoltage;
      }
    },

    sliderCurrent: function () {
      if (this.sliderCurrent != null) {
        this.modelCurrent = this.sliderCurrent;
      }
    },

    sliderFrequency: function () {
      if (this.sliderFrequency != null) {
        this.modelFrequency = this.sliderFrequency;
      }
    },

    modelVoltage: function () {
      if (this.modelVoltage != null) {
        this.sliderVoltage = this.modelVoltage;
        const container = document.getElementsByClassName("bgColor");
        container[0].style.height = this.computedHeight1;
      }
    },

    modelCurrent: function () {
      if (this.modelCurrent != null) {
        this.sliderCurrent = this.modelCurrent;
        const container = document.getElementsByClassName("bgColor2");
        container[0].style.height = this.computedHeight2;
      }
    },

    modelFrequency: function () {
      this.sliderFrequency = this.modelFrequency;
      if (this.modelFrequency != null) {
        const container = document.getElementsByClassName("bgColor2");
        container[1].style.height = this.computedHeight3;
      }
    },

    getCurrentDevice(newvalue) {
      if (newvalue != undefined) {
        this.wrrequest.cmd1 = this.getCurrentDevice.sae.s1 == 48 ? 48 : 49
        this.wrrequest.cmd2 = this.getCurrentDevice.sae.s2
        this.wrrequest.cmd3 = this.getCurrentDevice.sae.s4
        this.wrrequest.cmd4 = this.getCurrentDevice.sae.s5
        this.wrrequest.i = newvalue.sae.impiout
        this.wrrequest.v = newvalue.sae.impvout
        this.wrrequest.hz = newvalue.sae.imphzout
      }
    }
  },

  mounted() {
    this.sliderVoltage = this.getCurrentDevice.sae.impvout
    this.sliderCurrent = this.getCurrentDevice.sae.impiout
    this.sliderFrequency = this.getCurrentDevice.sae.imphzout
  },

  computed: {
    ...mapGetters(["getCurrentDevice", "getCurrentDevicePir"]),
    vOut() {
      return this.getCurrentDevice.sae.vout + " " + this.$t("common.unit.v");
    },
    iOut() {
      return this.getCurrentDevice.sae.iout + ".0 " + this.$i18n.t("common.unit.i");
    },
    hzOut() {
      return this.getCurrentDevice.sae.hzout + ".0 " + this.$i18n.t("common.unit.hz");
    },
    vRS() {
      return this.getCurrentDevice.sae.vinRS + " " + this.$i18n.t("common.unit.v");
    },
    vST() {
      return this.getCurrentDevice.sae.vinST + " " + this.$i18n.t("common.unit.v");
    },
    vTR() {
      return this.getCurrentDevice.sae.vinTR + " " + this.$i18n.t("common.unit.v");
    },
    outputline1() {
      return this.getCurrentDevice.sae.s5 == 48 ? 'ma-2 text-caption colorRun' : (this.nextLine == 48 ? 'ma-2 text-caption colorTemporary' : 'ma-2 text-caption')
    },
    outputline2() {
      return this.getCurrentDevice.sae.s5 == 49 ? 'ma-2 text-caption colorRun' : (this.nextLine == 49 ? 'ma-2 text-caption colorTemporary' : 'ma-2 text-caption')
    },
    outputline3() {
      return this.getCurrentDevice.sae.s5 == 50 ? 'ma-2 text-caption colorRun' : (this.nextLine == 50 ? 'ma-2 text-caption colorTemporary' : 'ma-2 text-caption')
    },
    current() {
      return this.getCurrentDevice.sae.s1 == 51 ? (this.getCurrentDevice.sae.s4 == 48 ? 'colorRun' : '') : (this.nextMode == 48 ? 'colorTemporary' : '')
    },
    voltage() {
      return this.getCurrentDevice.sae.s1 == 51 ? (this.getCurrentDevice.sae.s4 == 49 ? 'colorRun' : '') : (this.nextMode == 49 ? 'colorTemporary' : '')
    },
    saeOnOffLabel() {
      if (this.getCurrentDevice.sae) {
        return this.$i18n.t('common.status1.' + this.getCurrentDevice.sae.s1)
      }
      return "-"
    },
    vSlider() {
      return this.getCurrentDevice.sae && (this.getCurrentDevice.sae.s1 == 49 || this.getCurrentDevice.sae.s1 == 51) && this.getCurrentDevice.sae.s3 == 49 && this.getCurrentDevice.sae.s4 == 49
    },
    iSlider() {
      return this.getCurrentDevice.sae && (this.getCurrentDevice.sae.s1 == 49 || this.getCurrentDevice.sae.s1 == 51) && this.getCurrentDevice.sae.s3 == 49 && this.getCurrentDevice.sae.s4 == 48
    },
    hzSlider() {
      return this.getCurrentDevice.sae && (this.getCurrentDevice.sae.s1 == 49 || this.getCurrentDevice.sae.s1 == 51) && this.getCurrentDevice.sae.s3 == 49
    },
    saeLocalRemoteLabel() {
      if (this.getCurrentDevice.sae) {
        return this.$i18n.t('common.status3.' + this.getCurrentDevice.sae.s3)
      }
      return "-"
    },
    computedHeight1() {
      let res = (this.modelVoltage * 90) / 400;
      let difference = 44 / 2;
      return `calc(${res}% + ${difference}px)`;
    },
    computedHeight2() {
      let res = (this.modelCurrent * 90) / 20.0;
      let difference = 36 / 2;
      console.log(res);
      return `calc(${res}% + ${difference}px)`;
    },
    computedHeight3() {
      let res = ((this.modelFrequency - 10) * 90) / 20.0;
      let difference = 36 / 2;
      return `calc(${res}% + ${difference}px)`;
    },
  },

  methods: {
    ...mapActions(["doSetSAE", "doPingDevice"]),
    ...mapMutations(["mShowLongLoader", "mHideLongLoader", "mShowErrorMessage"]),
    down(domElement) {
      if (domElement == 0) {
        if (this.modelVoltage == 0) {
          console.log("min");
        } else {
          const container = document.getElementsByClassName("bgColor");
          this.modelVoltage = parseInt(this.modelVoltage) - 1;

          container[domElement].style.height = this.computedHeight;
        }
      } else if (domElement == 1) {
        if (this.modelVoltage == 0) {
          console.log("min");
        } else {
          const container = document.getElementsByClassName("bgColor");
          this.modelCurrent = parseInt(this.modelCurrent) - 1;

          container[domElement].style.height = this.computedHeight;
        }
      } else if (domElement == 2) {
        if (this.modelVoltage == 10) {
          console.log("min");
        } else {
          const container = document.getElementsByClassName("bgColor");
          this.modelFrequency = parseInt(this.modelFrequency) - 1;

          container[domElement].style.height = this.computedHeight;
        }
      }
    },

    up(domElement) {
      if (domElement == 0) {
        if (this.modelVoltage == 400) {
          console.log("max");
        } else {
          const container = document.getElementsByClassName("bgColor");
          this.modelVoltage = parseInt(this.modelVoltage) + 1;

          container[domElement].style.height = this.computedHeight;
        }
      } else if (domElement == 1) {
        if (this.modelCurrent == 20) {
          console.log("max");
        } else {
          const container = document.getElementsByClassName("bgColor");
          this.modelCurrent = parseInt(this.modelCurrent) + 1;

          container[domElement].style.height = this.computedHeight;
        }
      } else if (domElement == 2) {
        if (this.modelCurrent == 30) {
          console.log("max");
        } else {
          const container = document.getElementsByClassName("bgColor");
          this.modelFrequency = parseInt(this.modelFrequency) + 1;

          container[domElement].style.height = this.computedHeight;
        }
      }
    },

    selectOutputLine(cmd) { 
      this.wrrequest.cmd2 = this.wrrequest.cmd4 == cmd ? 48 : cmd
      this.wrrequest.cmd4 = cmd

      this.nextLine = cmd
    },

    toggleVoltageCurrent(cmd) {
      if (this.getCurrentDevice.sae.s1 != 49)
        this.wrrequest.cmd3 = cmd

      this.nextMode = cmd
    },

    async handleRunButton() {
      this.wrrequest.cmd1 = 49
      if (this.getCurrentDevice.sae.s1 != 49)
        await this.setDevice()
    },
    async handleStopButton() {
      this.wrrequest.cmd1 = 48
      await this.setDevice()
    },
    async handleResetButton() {
      this.wrrequest.cmd1 = 50
      await this.setDevice()
    },

    async setDevice() {
      this.dialogSiteClear = false

      this.wrrequest.v = this.modelVoltage
      this.wrrequest.i = this.modelCurrent
      this.wrrequest.hz = this.modelFrequency

      let payload = {
        id: this.$route.params.id,
        data: {
          wrrequest: this.wrrequest,
          timestamp: new Date(),
          confirmed: this.inboundLatencyChecked
        }
      }
      this.mShowLongLoader(this.$i18n.t("device.pleasewait"))
      let response = await this.doSetSAE(payload)
      this.mHideLongLoader()

      if (this.wrrequest.cmd1 == 49) {
        if (!this.timeout) {
          this.timeout = setTimeout(async function() {
            try {
              await this.doPingDevice(this.$route.params.id)
            }
            catch(e) {
              this.mShowErrorMessage(this.$i18n.t("err.device.keepalive"))
            }
          }.bind(this), 60000)
        }
      }
      else {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.inboundLatencyChecked = false
      }

      if (response.status == 400 && response.image) {
        if (this.inboundLatencyControl(response.image.img)) {
          this.inboundLatencyChecked = true

          this.inboundSnapshot = response.image.img
          this.dialogSiteClear = true
        }
        else {
          this.mShowErrorMessage(this.$i18n.t("err.device.inbound"))
        }
      }
      else if (response.status == 400) {
        if (this.wrrequest.cmd1 == 49) {
          this.mShowErrorMessage(this.$i18n.t("err.device.siteclear"))
        }
        else {
          this.inboundLatencyChecked = true
          this.inboundSnapshot = null
          this.dialogSiteClear = true
        }
      }
      else if (response.status == 406 || response.status == 500) {
        this.mShowErrorMessage(this.$i18n.t(response.message))
      }
    },

    inboundLatencyControl(snpashot) {
      var date = new Date()
      let mm = date.getUTCMonth() + 1 <= 9 ? "0" + (date.getUTCMonth() + 1) : date.getUTCMonth() + 1
      let dd = date.getUTCDate() <= 9 ? "0" + date.getUTCDate() : date.getUTCDate()
      let hh = date.getUTCHours() <= 9 ? "0" + date.getUTCHours() : date.getUTCHours()
      let mn = date.getUTCMinutes() <= 9 ? "0" + date.getUTCMinutes() : date.getUTCMinutes()
      let ss = date.getUTCSeconds() <= 9 ? "0" + date.getUTCSeconds() : date.getUTCSeconds()
      let nowUtc = "" + date.getUTCFullYear() + mm + dd + hh + mn + ss

      let picTime = snpashot.split("_")[1].split(".")[0]
      console.log("INBOUND LATENCY", nowUtc, picTime)

      return (nowUtc - picTime) <= 10
    }

  },
  beforeRouteLeave(to, from, next) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    next();
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.container-grad {
  width: 100%;
  height: 396px;
  border: 2px solid #556689;
  box-sizing: border-box;
  border-radius: 11px;
  position: relative;
  overflow: hidden;
}
.container-grad span {
  z-index: 100;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.9rem;
  width: 100%;
}
.container-grad2 span {
  height: 36px;
}
.bgColor {
  width: 100%;
  position: absolute;
  background-color: rgba(85, 102, 137, 0.6);
  bottom: 0;
  height: 22px;
  transition: all 0.3s ease;
}

.bgColor2 {
  height: 18px;
}
.border-row {
  padding: 10px;
  border-radius: 10px;
  border: 2px solid #556689;
}

.text-field-value {
  font-weight: 600 !important;
}

::v-deep [type="input"] {
  text-align: center !important;
}

::v-deep .theme--light.v-input input,
::v-deep .theme--light.v-input textarea {
  text-align: center !important;
}

::v-deep .v-application--is-ltr .v-input__prepend-outer,
::v-deep .v-application--is-ltr .v-input__append-outer {
  width: 100% !important;
  margin: 0px !important;
}
.height100 {
  height: 100% !important;
}
::v-deep .v-input__slider--vertical,
::v-deep .v-input__slider--vertical .v-input__slot,
::v-deep .v-input__slider--vertical .v-input__slot .v-slider--vertical {
  height: 100% !important;
}

::v-deep
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
 {
  border: 2px solid #556689 !important;
  border-radius: 11px !important;
  padding: 0px !important;
  overflow: hidden !important;
} 
::v-deep .v-btn:not(.v-btn--round).v-size--default {
  border-radius: 11px !important;
}

.line {
  height: 2px !important;
  width: 15px !important;
  background-color: #555;
  border: 1px solid #555;
  border-radius: 2px;
}
.line-left {
  margin-right: 25px;
}
.line-right {
  margin-left: 25px;
}

::v-deep .v-btn--fab.v-size--x-large {
  height: 120px !important;
  width: 120px !important;
}

.transitionColor {
  transition: all 0.2s ease;
}
.colorRun {
  background: rgb(27, 255, 176) !important;
  background: radial-gradient(
    circle,
    rgba(27, 255, 176, 1) 0%,
    rgba(0, 255, 115, 1) 50%,
    rgba(27, 255, 176, 1) 100%
  ) !important;
}
.colorStop {
  background-color: #bbb;
}
.colorError {
  background-color: #ef5350;
}
.colorTemporary {
  background-color: #fcf55f;
}

::v-deep .theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: #000 !important;
}

@keyframes fadein {
    from { opacity: 0.2; }
    to { opacity: 1; }
}

.runningImage {
  animation: fadein 2s ease-in alternate infinite;
  -webkit-animation: fadein 2s ease-in alternate infinite;
}
</style>
